import { useState } from "react";
import { useCurrentUser } from "@hooks/use-current-user";
import Button from "@components/core/Button";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import closetStates from "@utils/constants/closetStates";
import { getProductVariants } from "@utils/call-api/products-call";
import { productClickedEvent } from "@utils/events/product-events";
import catalogContexts from "@utils/constants/catalogContexts";
import QuickAddToClosetOffCanvas from "./QuickAddToClosetOffCanvas";
import QuickAddToClosetCustomInsideOffCanvas from "./QuickAddToClosetCustomInsideOffCanvas";

function QuickAddToCloset({ context, productSelected, dataFromAlgolia }) {
  const user = useCurrentUser();
  const currentCloset = useCustomizableCloset();

  const [loading, setLoading] = useState(false);
  const [customInsideOffCanvasIsOpened, setCustomInsideOffCanvasIsOpened] = useState(false);
  const [offCanvasIsOpened, setOffCanvasIsOpened] = useState(false);
  const [productWithVariants, setProductWithVariants] = useState({});

  const productAlreadyInCloset = currentCloset?.closet_items?.some(
    (ci) => ci.product.id === productSelected?.id?.toString(),
  );

  async function fetchProductVariants() {
    if (loading) return;

    setLoading(true);

    try {
      const res = await getProductVariants(productSelected?.slug);

      setProductWithVariants(res.data);
    } catch {
      setOffCanvasIsOpened(false);
      setCustomInsideOffCanvasIsOpened(false);
    } finally {
      setLoading(false);
    }
  }

  function openOffCanvas(device) {
    device === "mobile" ? setCustomInsideOffCanvasIsOpened(true) : setOffCanvasIsOpened(true);
    fetchProductVariants();
    productClickedEvent(dataFromAlgolia, "quickAdd");
  }

  function renderMobileOrDesktopButton() {
    return (
      <>
        <Button
          variant="outline-primary"
          size="sm"
          leftIconName="drawer_icon"
          onClick={() => openOffCanvas("mobile")}
          className="d-lg-none quick-add-to-closet-btn"
        />
        <Button
          variant="outline-primary"
          size="sm"
          leftIconName="drawer_icon"
          onClick={() => openOffCanvas("desktop")}
          className="d-none d-lg-block quick-add-to-closet-btn"
        />
      </>
    );
  }

  if (
    !user ||
    context === catalogContexts.sales ||
    !productSelected?.id ||
    currentCloset?.state !== closetStates.readyToChange
  ) {
    return null;
  }

  return (
    <div>
      <div className="catalog-product-quick-add-to-closet">
        {productAlreadyInCloset ? (
          <Button
            key={`${productSelected?.id}-product-already-in-closet`}
            variant="primary"
            size="sm"
            leftIconName="new-checkmark"
            onClick={() => {}}
            className="quick-add-to-closet-btn-checked"
          />
        ) : (
          renderMobileOrDesktopButton()
        )}
      </div>

      <QuickAddToClosetOffCanvas
        show={!loading && customInsideOffCanvasIsOpened}
        onHide={() => setCustomInsideOffCanvasIsOpened(false)}
        productWithVariants={productWithVariants}
        dataFromAlgolia={dataFromAlgolia}
      />

      <QuickAddToClosetCustomInsideOffCanvas
        show={!loading && offCanvasIsOpened}
        onHide={() => setOffCanvasIsOpened(false)}
        productWithVariants={productWithVariants}
        dataFromAlgolia={dataFromAlgolia}
      />
    </div>
  );
}

export default QuickAddToCloset;
